import styled from '@emotion/styled'

export const ImageWrapper = styled.div`
  display: grid;
  place-items: center;
`

export const ImageContainer = styled.div`
  width: 200px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 8px;
`

export const LocationImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 4px;
`

export const NoImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  color: #888;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
`
